<script setup>
import { computed, ref, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import StaffChatMessage from './StaffChatMessage.vue';

const props = defineProps({
  messages: {
    type: Array,
    default: () => [],
  },
  currentUserId: {
    type: Number,
    required: true,
  },
  isGroupChat: {
    type: Boolean,
    default: false,
  },
});

const MEDIA_ATTACHMENT_TYPES = ['image', 'video', 'audio'];

const { t } = useI18n();
const scrollContainer = ref(null);

const sortedMessages = computed(() => {
  return [...props.messages].sort((a, b) => a.createdAt - b.createdAt);
});

const scrollToBottom = async () => {
  await nextTick();
  if (scrollContainer.value) {
    scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
  }
};

watch(
  () => props.messages.length,
  () => scrollToBottom(),
  { immediate: true }
);

const galleryAttachments = computed(() => {
  const mediaAttachments = [];

  sortedMessages.value.forEach(message => {
    (message.attachments || []).forEach(attachment => {
      if (MEDIA_ATTACHMENT_TYPES.includes(attachment.fileType)) {
        mediaAttachments.push({
          ...attachment,
          messageId: message.id,
        });
      }
    });
  });

  return mediaAttachments;
});
</script>

<template>
  <div
    ref="scrollContainer"
    class="flex flex-col flex-1 min-h-0 px-4 py-4 overflow-y-auto"
  >
    <p
      v-if="!sortedMessages.length"
      class="py-8 text-sm text-center text-n-slate-11"
    >
      {{ t('STAFF_CHAT.NO_MESSAGES') }}
    </p>
    <template v-for="message in sortedMessages" :key="message.id">
      <StaffChatMessage
        :message="message"
        :current-user-id="currentUserId"
        :gallery-attachments="galleryAttachments"
        :is-group-chat="isGroupChat"
      />
    </template>
  </div>
</template>
